/**
 * ModifierSelector - Options/modifiers selection (No Ice, etc.)
 */
import { memo } from 'react';
import { Check } from 'lucide-react';

const ModifierSelector = memo(function ModifierSelector({ 
  modifiers = [], 
  selectedModifiers = [], 
  onToggleModifier,
  getModifierPrice,
  stepNumber = 2 
}) {
  if (modifiers.length === 0) return null;

  return (
    <div>
      <h4 className="font-medium text-base mb-2 flex items-center gap-2">
        <span className="w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center text-xs text-primary font-bold">
          {stepNumber}
        </span>
        Options
      </h4>
      <div className="space-y-2">
        {modifiers.map(modifier => {
          const isSelected = selectedModifiers.find(m => m.name === modifier.name);
          const price = getModifierPrice(modifier);
          return (
            <button
              key={modifier.name}
              onClick={() => onToggleModifier(modifier)}
              data-testid={`modifier-${modifier.name.toLowerCase().replace(/\s+/g, '-')}`}
              className={`w-full p-3 rounded-xl border-2 transition-all flex items-center justify-between ${
                isSelected
                  ? 'border-primary bg-primary/10'
                  : 'border-border bg-card hover:border-primary/50'
              }`}
            >
              <div className="flex items-center gap-2">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                  isSelected ? 'border-primary bg-primary' : 'border-muted-foreground'
                }`}>
                  {isSelected && <Check className="w-3 h-3 text-white" />}
                </div>
                <div className="text-left">
                  <span className="font-medium text-sm">{modifier.name}</span>
                  {modifier.description && (
                    <p className="text-xs text-muted-foreground">{modifier.description}</p>
                  )}
                </div>
              </div>
              {price > 0 && (
                <span className="text-primary font-medium text-sm">+${price.toFixed(2)}</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
});

export default ModifierSelector;
